import React from 'react'
import Who_1 from '../../../assets/images/home_page_4/careers/09.png'
import Who_2 from '../../../assets/images/home_page_4/careers/10.png'
import Who_3 from '../../../assets/images/home_page_4/careers/11.png'

const WhoWeAre = () => {
    return (
        <>
            <section className="who-we-are-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="career-dtls">
                                <h3 className="sub-career-heading">Who We Are</h3>
                                <h2 className="career-heading">
                                    Dare To Dream Big, Succeed In Your Career!
                                </h2>
                                <p className="about-career-dtls">
                                    Et purus duis sollicitudin dignissim habitant. Egestas nulla quis
                                    venenatis cras sed eu massa eu faucibus Urna fusce Et purus do
                                    sollicitudin dignissim habitant. Egestas nulla dignissim habi tant.
                                    Egestas nulla quis venenatis in dignissim{" "}
                                </p>
                                <div className="who-we-are-list">
                                    <ul>
                                        <li>
                                            <i className="flaticon-check" />
                                            Career Catalyst
                                        </li>
                                        <li>
                                            <i className="flaticon-check" />
                                            Job Navigator
                                        </li>
                                        <li>
                                            <i className="flaticon-check" />
                                            Professional Edge
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="career-img">
                                <div className="row align-items-center">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="career-img-1">
                                            <img
                                                src={Who_1}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <img
                                            src={Who_2}
                                            className="img-fluid mb-3"
                                            alt=""
                                        />
                                        <img
                                            src={Who_3}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WhoWeAre
